import { useTranslation } from 'react-i18next'
import { Button } from '@/components/atoms'
import { UsageAndCostExportReportDropdown } from './UsageAndCostExportReportDropdown'
import { useGlobalModalStore } from '@/stores/useGlobalModalStore/useGlobalModalStore'
import { SaveReportContent } from '@/components/molecules/SaveReportContent/SaveReportContent'
import { UsageCostRequestParams } from '@/hooks'

export const UsageAndCostActions: React.FC<{
    filters: UsageCostRequestParams
}> = ({ filters }) => {
    const { t } = useTranslation('translations')

    const setModalState = useGlobalModalStore((state) => state.setModalState)
    const closeModal = () => {
        setModalState({ isOpen: false })
    }

    const labels = {
        saveButton: t('reporting.save_report.save_report_modal.save_button'),
        loadingSaveButton: t(
            'reporting.save_report.save_report_modal.loading_save_button'
        ),
    }

    const handleClickSaveReport = () => {
        setModalState({
            isOpen: true,
            title: t('reporting.save_report.save_report_modal.title'),
            description: t(
                'reporting.save_report.save_report_modal.description'
            ),
            content: () => (
                <SaveReportContent reportType="usage-cost" labels={labels} />
            ),
            onClose: closeModal,
        })
    }

    return (
        <div className="flex gap-4">
            <Button
                name="saveReport"
                size="large"
                variant="outlinePrimary"
                onClick={() => {
                    handleClickSaveReport()
                }}
                className="font-medium"
                data-walkthrough="save-report-button"
            >
                {t('common.save_report')}
            </Button>

            <div data-walkthrough="export-report-button">
                <UsageAndCostExportReportDropdown filters={filters} />
            </div>
        </div>
    )
}
